import React from "react";
import { setKey } from '../../api/insurance-takers/actions'
import { electronicPublication } from "../../api/electronic-publications/reducers";

class ContactInfoCollection extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            errors: {
                cellularPhone: '',
                email: '',
            },
            afthokkun: true
        }
        this.onChangeTextInput = this.onChangeTextInput.bind(this)
        this.onChangeTextInputTrim = this.onChangeTextInputTrim.bind(this)
        this.onClickConfirm = this.onClickConfirm.bind(this)
        this.onClickChange = this.onClickChange.bind(this)
        this.validateForm = this.validateForm.bind(this)
        this.receiveElectronicPublicationChange = this.receiveElectronicPublicationChange.bind(this)

        this.email = React.createRef()
        this.cellularPhone = React.createRef()
    }
    
    componentDidMount(){
      // Initialize key
      this.props.dispatch(setKey({ key: "electronicPublication", value: true }, this.props.customerId))
    }

    validateForm() {
        let errors = this.state.errors
        let emailCheck = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/
        let valid = true;

        Object.keys(errors).forEach(key => {

            switch (key) {

                case 'cellularPhone':

                    let cellularPhoneValue = this.cellularPhone.current.value
                    if (cellularPhoneValue.length == 7) {
                        errors.cellularPhone = ''
                    }
                    else {
                        errors.cellularPhone = 'Símanúmer er ekki gilt'
                        valid = false;
                    }
                    break;

                case 'email':

                    let value = this.email.current.value
                    if ((RegExp(emailCheck).test(value) && value.length > 0)) {
                        errors.email = ''
                    } else {
                        errors.email = 'Netfang er ekki gilt';
                        valid = false
                    }
                    break;

                default:
                    break;

            }
        });
        this.setState({ errors: errors })
        return valid;
    }

    onChangeTextInput(event) {
        this.props.dispatch(setKey({ key: event.target.name, value: event.target.value }, this.props.customerId))
    }

    onChangeTextInputTrim(event) {
        this.props.dispatch(setKey({ key: event.target.name, value: event.target.value.trim() }, this.props.customerId))
    }

    onClickConfirm(event) {
        let validate = this.validateForm()

        if (validate) {
            Promise.resolve(this.props.dispatch(setKey({ key: event.target.name, value: true }, this.props.customerId)))
        }
    }

    onClickChange(event) {
        this.props.dispatch(setKey({ key: event.target.name, value: false }, this.props.customerId))
    }

    receiveElectronicPublicationChange(event){
      this.props.dispatch(setKey({ key: "electronicPublication", value: !this.state.afthokkun }, this.props.customerId))
      this.setState({ afthokkun: !this.state.afthokkun})
    }

    render() {
        const { initialValues, customerId } = this.props

        return (
            <>
                <form className="contract-form">
                    <div className={`${this.state.errors.cellularPhone.length > 0 ? 'error' : ''} form-row align-items-center`}>
                        <label htmlFor="base-cellularPhone" className="col-sm-6 col-form-label">
                            Farsímanúmer
                                    {this.state.errors.cellularPhone.length > 0 ?
                                <span className="error"> ({this.state.errors.cellularPhone}) </span> : ''
                            }
                        </label>
                        <div className="col-sm-6">
                            <input ref={this.cellularPhone} id="base-cellularPhone" type="tel" pattern="[0-9]" className="form-control text-right" name="cellularPhone" placeholder="Sláðu inn símanúmer" onChange={this.onChangeTextInput} value={initialValues.cellularPhone} disabled={initialValues.contactInfoConfirm} />
                        </div>
                    </div>

                    <div className="form-row align-items-center">
                        <label htmlFor="base-phonenumber" className="col-sm-6 col-form-label">Símanúmer</label>
                        <div className="col-sm-6">
                            <input id="base-phonenumber" type="tel" pattern="[0-9]" className="form-control text-right" name="phonenumber" placeholder="Sláðu inn símanúmer" onChange={this.onChangeTextInput} value={initialValues.phonenumber} disabled={initialValues.contactInfoConfirm} />
                        </div>
                    </div>

                    <div className={`${this.state.errors.email.length > 0 ? 'error' : ''} form-row align-items-center`}>
                        <label htmlFor="base-email" className="col-sm-6 col-form-label">
                            Netfang
                                    {this.state.errors.email.length > 0 ?
                                <span className="error"> ({this.state.errors.email}) </span> : ''
                            }
                        </label>
                        <div className="col-sm-6">
                            <input ref={this.email} id="base-email" type="text" className="form-control text-right" name="email" placeholder="Sláðu inn netfang" onChange={this.onChangeTextInputTrim} value={initialValues.email} disabled={initialValues.contactInfoConfirm} />
                        </div>
                    </div>
                    <div className={`form-row align-items-center no-paper-container`}>
                        <div className="no-paper-check">
                            <input ref={this.electronicPublication} type="checkbox" id={`el-pub-${customerId}`} name="el-pub" onChange={this.receiveElectronicPublicationChange} checked={this.state.afthokkun} disabled={initialValues.contactInfoConfirm} />
                            <label htmlFor={`el-pub-${customerId}`} className="col-form-label"></label>
                        </div>
                        <div className="col-6 col-form-label text-left no-paper">
                            <label className="col-form-label" htmlFor={`el-pub-${customerId}`}>
                              Afþakka yfirlit á pappír
                            </label>
                        </div>
                    </div>
                </form>
                <div className="col-12 text-right button-container">
                    {initialValues.contactInfoConfirm ?
                        (<button className="btn btn-primary xs-m-10" name="contactInfoConfirm" onClick={this.onClickChange}> Breyta </button>) :
                        (<button className="confirm-btn btn btn-primary xs-m-10" name="contactInfoConfirm" onClick={this.onClickConfirm} > Staðfesta </button>)}
                </div>
            </>
        )
    }
}

export default ContactInfoCollection